import { Tabs } from "antd-mobile";
import React from "react";

import "./style.scss";

const CustomTabs = ({
  onTabChange = () => {},
  tabItems = [],
  activeKey,
  stretch = true,
  customTabContainerStyle = "",
}) => {
  return (
    <div className="agent-mobile-custom-tabs">
      <Tabs
        onChange={onTabChange}
        activeKey={activeKey}
        stretch={stretch}
        className={customTabContainerStyle}
      >
        {tabItems?.map((tabItem, index) => {
          return <Tabs.Tab {...tabItem}>{tabItem?.component}</Tabs.Tab>;
        })}
      </Tabs>
    </div>
  );
};

export default CustomTabs;
